import { render, staticRenderFns } from "./services.vue?vue&type=template&id=6c40018a&"
import script from "./services.vue?vue&type=script&lang=js&"
export * from "./services.vue?vue&type=script&lang=js&"
import style0 from "./services.vue?vue&type=style&index=0&id=6c40018a&prod&lang=scss&"
import style1 from "./services.vue?vue&type=style&index=1&id=6c40018a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports